import { Component, inject, input } from '@angular/core';
import { OrderGroup } from 'src/app/common/OrderGroup';
import { reservationStatusBadgeClass, reservationStatusLabel } from 'src/app/common/ReservationStatus';
import { Router } from '@angular/router';
import { OrderGroupOrderItemComponent } from '../order-group-order-item/order-group-order-item.component';
import { CommonModule } from '@angular/common';

@Component({
    imports: [CommonModule, OrderGroupOrderItemComponent],
    selector: 'app-order-group-list-item',
    templateUrl: './order-group-list-item.component.html'
})
export class OrderGroupListItemComponent {
  private router = inject(Router);

  readonly orderGroup = input<OrderGroup>();

  /** #178: the badge's wording and colour come from the enum's own display map. Empty for a
   *  reserved order — the ordinary case wears no badge. #168: Unknown wears the pending badge —
   *  an outcome this build does not recognise must not pass as a finished order. */
  public get statusLabel(): string {
    return reservationStatusLabel(this.orderGroup()?.reservationStatus);
  }

  public get statusBadgeClass(): string {
    return reservationStatusBadgeClass(this.orderGroup()?.reservationStatus);
  }

  public onEditOrderGroup() {
    this.router.navigateByUrl(`/shop-order-group-edit/${this.orderGroup().id}`);
  }
}
